document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".shopify-app-block").forEach((block) => {
    const looxReviews = block.querySelector("#looxReviews");
    if (looxReviews) {
      const section = block.closest(".shopify-section");
      if (section) {
        section.classList.add("bg-black-main", "font-riviera");
      }
    }
  });

  const colorInput = document.querySelector(".js-color-value-input");
  if (colorInput) {
    const colorButtons = document.querySelectorAll(".js-custom-color-pick-btn, .js-default-color-pick-btn");
    if (colorButtons) {
      colorButtons.forEach((button) => {
        button.addEventListener("click", () => {
          colorInput.value = button.dataset.value + `(${button.dataset.color})`;
          console.log(colorInput.value);
        });
      });
    }
  }
});
